import s from "../productCardV3.module.css";
import {ritaIcon} from "../../../assets";

const ProductVendorBadge = (props) => {
    // Destructured props
    const {
        formattedHref,
        tablePrice
    } = props;

    // Prevents errors
    if (
        !tablePrice.tableCode ||
        !tablePrice.label
    ) {
        return null;
    }

    return (
        <div
            className={`${s.serviceType} font-museo dark:!bg-contrast-yellow flex gap-[0.5rem] text-[12px]`}
            data-testid={`rita-product-card-badge-container-${formattedHref}`}
            style={{
                backgroundColor: tablePrice.color || "rgb(112, 107, 255)"
            }}
        >
            <img
                src={ritaIcon}
                alt="rita icon"
            />
            <div className="flex flex-col items-start">
                <p
                    data-testid={`rita-product-card-badge-${formattedHref}`}
                    className={"dark:text-black font-semibold uppercase"}
                >
                    {tablePrice.label}
                </p>
                <p
                    data-testid={`rita-product-card-badge-${formattedHref}`}
                    className={"dark:text-black"}
                >
                    Desconto Rita
                </p>
            </div>
        </div>
    )
}

export default ProductVendorBadge;
